(() => {
  if (window.nxoCartExtrasBooted) return;
  window.nxoCartExtrasBooted = true;
  const source = document.querySelector('[data-nxo-cart-extras-source]');
  if (!source) return;
  const threshold = Number(source.dataset.threshold);
  const guideTemplate = source.querySelector('[data-nxo-cart-guide-template]');
  const flashTemplate = source.querySelector('[data-nxo-cart-flash-template]');
  const drawerSelector = '.Vtl-CartDrawer__Container--IsVisible,cart-drawer.active .drawer__inner';
  const root = window.Shopify?.routes?.root || '/';
  const locale = source.dataset.currency === 'COP' && source.dataset.locale === 'es' ? 'es-CO' : source.dataset.locale || 'es-CO';
  const money = new Intl.NumberFormat(locale, {
    style: 'currency', currency: source.dataset.currency || 'COP', currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0,
  });
  let cart;
  try { cart = JSON.parse(source.querySelector('[data-nxo-cart-initial]').textContent); } catch {}
  let refreshTimer;
  let revision = 0;
  let lastDrawer;
  let submitting = false;

  function mount() {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) { lastDrawer = null; return; }
    if (!drawer.querySelector('[data-nxo-cart-guide]')) {
      const header = drawer.querySelector('.Vtl-CartDrawerHeader,.drawer__header');
      if (header) header.after(guideTemplate.content.cloneNode(true));
    }
    if (!drawer.querySelector('[data-nxo-cart-flash]')) {
      const content = drawer.querySelector('.Vtl-CartDrawer__Container-Content-TopContainer,cart-drawer-items');
      if (content) content.append(flashTemplate.content.cloneNode(true));
    }
    if (cart) paint(drawer);
    if (lastDrawer !== drawer) {
      lastDrawer = drawer;
      scheduleRefresh();
    }
  }

  function paint(drawer) {
    const nonempty = Number(cart.item_count) > 0;
    const shipping = drawer.querySelector('[data-nxo-cart-shipping]');
    if (shipping) {
      shipping.hidden = !nonempty || source.dataset.currency !== 'COP';
      const total = Math.max(0, Number(cart.total_price) || 0);
      const remaining = Math.max(0, threshold - total);
      const label = shipping.querySelector('[data-nxo-cart-progress-label]');
      label.textContent = remaining > 0
        ? source.dataset.remaining.replace('[amount]', money.format(remaining / 100))
        : source.dataset.reached;
      const track = shipping.querySelector('[role="progressbar"]');
      track.setAttribute('aria-valuenow', String(Math.min(total, threshold) / 100));
      track.setAttribute('aria-valuetext', label.textContent);
      track.dataset.reached = String(remaining === 0);
      shipping.querySelector('[data-nxo-cart-progress]').style.width = `${Math.min(100, total / threshold * 100)}%`;
    }
    const flash = drawer.querySelector('[data-nxo-cart-flash]');
    if (flash) {
      const present = new Set((cart.items || []).map(item => String(item.product_id)));
      let visible = 0;
      flash.querySelectorAll('[data-nxo-flash-form]').forEach(form => {
        form.hidden = present.has(form.dataset.productId);
        if (!form.hidden) visible += 1;
      });
      flash.hidden = !nonempty || visible === 0;
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, 180);
  }

  async function refreshCart() {
    const current = ++revision;
    try {
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const result = await response.json();
      if (current !== revision) return;
      cart = result;
      const drawer = document.querySelector(drawerSelector);
      if (drawer) paint(drawer);
    } catch {}
  }

  document.addEventListener('change', event => {
    const select = event.target.closest('[data-nxo-flash-form] select');
    if (!select) return;
    const form = select.closest('form');
    const option = select.selectedOptions[0];
    if (option?.dataset.money) form.querySelector('[data-nxo-flash-price]').textContent = option.dataset.money;
    form.querySelector('[type="submit"]').disabled = !select.value;
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-nxo-flash-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting || !form.elements.id.value) return;
    submitting = true;
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-nxo-flash-error]');
    const select = form.querySelector('select');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    const body = new FormData(form);
    if (select) select.disabled = true;
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);
    try {
      const response = await fetch(form.action, {
        method: 'POST', credentials: 'same-origin', body,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const result = await response.json();
      if (!response.ok || result.status || result.errors) throw new Error(result.description || source.dataset.error);
      await refreshCart();
      const appDrawer = document.querySelector('.Vtl-CartDrawer__Container--IsVisible');
      if (!appDrawer) {
        const native = document.querySelector('cart-drawer');
        if (native && result.sections?.['cart-drawer']) {
          native.setActiveElement(document.querySelector('#cart-icon-bubble'));
          native.renderContents(result);
        }
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nxo-cart-flash', productVariantId: body.get('id'), cartData: result });
      }
      mount();
    } catch (failure) {
      error.textContent = failure.message || source.dataset.error;
      error.hidden = false;
    } finally {
      submitting = false;
      if (select) select.disabled = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);

  document.addEventListener('nexo:cart-added', event => {
    if (event.detail?.confirmed === true) scheduleRefresh();
  });
  const observer = new MutationObserver(records => {
    const external = records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target?.closest('[data-nxo-cart-owned],[data-nxo-cart-extras-source]')) return false;
      if (record.type === 'childList') {
        const nodes = [...record.addedNodes, ...record.removedNodes];
        if (nodes.length && nodes.every(node => node.nodeType === 1 && node.matches('[data-nxo-cart-owned]'))) return false;
      }
      return target?.matches('cart-drawer,.Vtl-CartDrawer__Container')
        || !!target?.closest('cart-drawer,.Vtl-CartDrawer__Container')
        || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(drawerSelector) || node.querySelector(drawerSelector)));
    });
    if (!external) return;
    mount();
    if (document.querySelector(drawerSelector)) scheduleRefresh();
  });
  observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'value'] });
  mount();
})();
